module.exports = __webpack_public_path__ + "static/media/Jean-Philippe Roch.1fa535f8.png";